import React, { useEffect, useState } from "react";
import { getAllTransactions } from "../../../../api/transaction";
import { Link } from "react-router-dom";

const CoinBuyTable = ({ coinId, bgChange, refresh }) => {
  const [buyData, setBuyData] = useState([]);

  useEffect(() => {
    if (!coinId) return;

    const fetchTransactions = async () => {
      try {
        const response = await getAllTransactions({
          page: 1,
          limit: 6,
          coinId: [coinId],
          type: "buy",
        });

        // Use response.data which contains the array of transactions
        setBuyData(response.data || []);
      } catch (error) {
        console.error("Failed to fetch transactions:", error);
      }
    };

    fetchTransactions();
  }, [coinId, refresh]);

  return (
    <div className="card price-list">
      <div className="card-header border-0 pb-2">
        <h4 className={`mb-0 text-${bgChange}`}>Buy Order</h4>
      </div>

      <div className="card-body p-3 py-0">
        <div className="table-responsive">
          <table className={`table text-center order-tbl bg-${bgChange}-hover`}>
            <thead>
              <tr>
                <th className="text-left">Qty.</th>
                <th className="text-center">Price</th>
                <th className="text-right">Total</th>
              </tr>
            </thead>
            <tbody>
              {buyData.length > 0 ? (
                buyData.map((item, index) => {
                  const quantity = Number(item.quantity) || 0;
                  const price = Number(item?.price) || 0;
                  const total = (quantity * price).toFixed(2);

                  return (
                    <tr key={item.id || index}>
                      <td className="text-left">{quantity || "0"}</td>
                      <td className="text-center">{price || "0"}</td>
                      <td className="text-right">{total}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={3}>No buy orders found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="card-footer text-center py-3 border-0">
        <Link to="/statement" className="btn-link text-black">
          Show more <i className="fa fa-caret-right"></i>
        </Link>
      </div>
    </div>
  );
};

export default CoinBuyTable;
